import axios from 'axios';

import { RequestTransformer, ResponseTransformer } from '../types';

export const defaultTransformRequest = ([] as RequestTransformer[]).concat(
  axios.defaults.transformRequest ?? [],
);
export const defaultTransformResponse = ([] as ResponseTransformer[]).concat(
  axios.defaults.transformResponse ?? [],
);
